/*
  Offers in the tote (snippets/mm-cart-offers.liquid).

  Codes go on the cart through Shopify's own cart discount support, so checkout
  charges exactly what the tote shows. After every change the drawer and the cart
  page sections are re-rendered from Shopify's response.

  Clashing codes: GOODMOOD and MOOD5 are both product discounts, and on the Basic
  plan only one product discount applies per item. When a new code knocks another
  out (or is knocked out), the tote keeps whichever saves more and says so.

  Auto-apply: when no code is applied, the highest priority offer marked
  "Apply automatically" is tried once per visit. "First order only" offers are
  tried only for signed-in customers with no past orders, or when the shopper
  claimed that code from the welcome popup. A code the shopper removes is not
  added back in the same visit.

  Words: every message comes from the <script data-mm-i18n> block inside the
  component (locale keys under mm.offers). The tote is re-rendered after every change,
  so the block is read again each time a message is written, never cached. English
  below is the fallback when a key is missing.
*/
(function () {
  if (customElements.get('mm-cart-offers')) return;

  var REMOVED_KEY = 'mmOffersRemoved';
  var TRIED_KEY = 'mmOffersTried';
  var busy = false;
  var pendingMessage = null;
  var saleTried = {}; /* the sale code is tried once per page view even when sessionStorage is blocked */

  var FALLBACK = {
    already: '[code] is already applied.',
    applied: '[code] applied.',
    appliedAuto: '[code] applied automatically.',
    replaced: '[code] replaces [others]. They can\'t be combined.',
    kept: '[others] saves you more, so we kept it. [code] can\'t be combined with it.',
    invalid: '[code] can\'t be used on this tote. Check the code, or what\'s in your tote.',
    removed: '[code] removed.',
    empty: 'Enter a code first.',
    network: 'We couldn\'t update your tote. Check your connection and try again.',
    listPair: '[first] and [last]',
    showFewer: 'Show fewer offers'
  };

  /* Shopify may hand the words over HTML-escaped; turn entities back into characters for textContent. */
  function decode(text) {
    if (text.indexOf('&') === -1) return text;
    var box = document.createElement('textarea');
    box.innerHTML = text;
    return box.value;
  }

  /* One message, read fresh from whichever offers box is on the page now. */
  function t(key, vars) {
    var words = {};
    var block = document.querySelector('mm-cart-offers [data-mm-i18n]');
    if (block) { try { words = JSON.parse(block.textContent) || {}; } catch (e) { words = {}; } }
    var text = words[key];
    if (typeof text !== 'string' || !text || text.indexOf('translation missing') !== -1) text = FALLBACK[key] || '';
    text = decode(text);
    Object.keys(vars || {}).forEach(function (name) {
      text = text.split('[' + name + ']').join(vars[name]);
    });
    return text;
  }

  function readList(key) {
    try { return JSON.parse(sessionStorage.getItem(key) || '[]'); } catch (e) { return []; }
  }
  function addToList(key, code) {
    try {
      var list = readList(key);
      if (list.indexOf(code) === -1) list.push(code);
      sessionStorage.setItem(key, JSON.stringify(list));
    } catch (e) {}
  }
  function dropFromList(key, code) {
    try {
      sessionStorage.setItem(key, JSON.stringify(readList(key).filter(function (c) { return c !== code; })));
    } catch (e) {}
  }

  /* Customer events for the custom pixel (Settings > Customer events): coupon_apply_click when a shopper
     asks for a code, coupon_result with what happened, coupon_remove. Payload amounts are in rupees. */
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* ignore */ }
  }
  function rupees(cents) { return Math.round((cents || 0)) / 100; }

  function sectionsToRender() {
    var list = [];
    if (document.getElementById('CartDrawer')) list.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) list.push('cart-icon-bubble');
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset.id) list.push(items.dataset.id);
    if (footer && footer.dataset.id) list.push(footer.dataset.id);
    return list;
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function paint(state) {
    var sections = state.sections || {};
    var drawerEl = document.getElementById('CartDrawer');
    if (drawerEl && sections['cart-drawer']) {
      var fresh = parse(sections['cart-drawer']).getElementById('CartDrawer');
      if (fresh) {
        drawerEl.innerHTML = fresh.innerHTML;
        var drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.classList.toggle('is-empty', state.item_count === 0);
        var overlay = drawerEl.querySelector('#CartDrawer-Overlay');
        if (drawer && overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var freshBubble = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
    }
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || !el.dataset.id || !sections[el.dataset.id]) return;
      var target = el.querySelector('.js-contents');
      var source = parse(sections[el.dataset.id]).querySelector('.js-contents');
      if (target && source) target.innerHTML = source.innerHTML;
    });
  }

  function setCodes(codes) {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        discount: codes.join(','),
        sections: sectionsToRender(),
        sections_url: window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart update failed');
      return r.json();
    });
  }

  function applicableCodes(state) {
    return (state.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code.toUpperCase(); });
  }
  function isApplicable(state, code) {
    return applicableCodes(state).indexOf(code) !== -1;
  }
  function listNames(codes) {
    if (codes.length <= 1) return codes.join('');
    return t('listPair', { first: codes.slice(0, -1).join(', '), last: codes[codes.length - 1] });
  }

  function finish(state, message, tone) {
    pendingMessage = message ? { text: message, tone: tone || 'info' } : null;
    paint(state);
    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mm-cart-offers', cartData: state });
    }
    return state;
  }

  /* Apply one code on top of the ones already working, then settle any clash. */
  function applyCode(code, before, opts) {
    opts = opts || {};
    var kept = before.slice();
    var beforeSaving = opts.beforeSaving || 0;
    if (kept.indexOf(code) !== -1) {
      return Promise.resolve({ ok: true, message: t('already', { code: code }), noop: true });
    }
    return setCodes(kept.concat(code)).then(function (both) {
      var nowWorking = applicableCodes(both);
      var dropped = kept.filter(function (c) { return nowWorking.indexOf(c) === -1; });

      if (isApplicable(both, code) && dropped.length === 0) {
        finish(both, t(opts.silent ? 'appliedAuto' : 'applied', { code: code }), 'good');
        return { ok: true, result: 'applied', state: both };
      }

      /* The new code works but pushed another out: keep it only if it saves more. */
      if (isApplicable(both, code)) {
        if (both.total_discount >= beforeSaving) {
          return setCodes(nowWorking).then(function (s) {
            finish(s, t('replaced', { code: code, others: listNames(dropped) }), 'info');
            return { ok: true, result: 'replaced_other', state: s };
          });
        }
        return setCodes(kept).then(function (s) {
          finish(s, t('kept', { code: code, others: listNames(dropped) }), 'info');
          return { ok: false, result: 'kept_other', state: s };
        });
      }

      /* The new code did not apply. Try it alone to tell a clash from a bad code. */
      if (kept.length === 0) {
        return setCodes([]).then(function (s) {
          finish(s, opts.silent ? null : t('invalid', { code: code }), 'error');
          return { ok: false, result: 'invalid', state: s };
        });
      }
      return setCodes([code]).then(function (alone) {
        if (isApplicable(alone, code) && alone.total_discount > beforeSaving) {
          finish(alone, t('replaced', { code: code, others: listNames(kept) }), 'info');
          return { ok: true, result: 'replaced_other', state: alone };
        }
        return setCodes(kept).then(function (s) {
          var result = 'invalid';
          if (isApplicable(alone, code)) {
            result = 'kept_other';
            finish(s, t('kept', { code: code, others: listNames(kept) }), 'info');
          } else {
            finish(s, opts.silent ? null : t('invalid', { code: code }), 'error');
          }
          return { ok: false, result: result, state: s };
        });
      });
    });
  }

  class MmCartOffers extends HTMLElement {
    connectedCallback() {
      var raw = this.querySelector('[data-mm-offers-data]');
      try { this.data = JSON.parse(raw ? raw.textContent : '{}'); } catch (e) { this.data = { applied: [], offers: [] }; }
      this.msg = this.querySelector('[data-mm-offers-msg]');
      this.form = this.querySelector('[data-mm-offers-form]');
      this.input = this.form ? this.form.querySelector('input') : null;

      if (pendingMessage) this.say(pendingMessage.text, pendingMessage.tone);

      if (this.input) {
        this.input.addEventListener('input', this.say.bind(this, '', 'info'));
        this.input.addEventListener('keydown', function (event) {
          if (event.key === 'Enter') this.onSubmit(event);
        }.bind(this));
      }
      this.addEventListener('click', this.onClick.bind(this));
      /* Dawn's cart-items treats every change event inside it as a quantity edit; keep ours to ourselves. */
      this.addEventListener('change', function (event) { event.stopPropagation(); });

      /* Auto-apply runs once, from the drawer's box; the tote page's box runs it only when
         the drawer box is not on the page (no drawer, or the drawer placement is off). */
      if (this.dataset.context === 'drawer' || !document.querySelector('mm-cart-offers[data-context="drawer"]')) {
        setTimeout(this.autoApply.bind(this), 0);
      }
    }

    working() {
      return (this.data.applied || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
    }

    say(text, tone) {
      if (!this.msg) return;
      this.msg.textContent = text || '';
      this.msg.dataset.tone = tone || 'info';
    }

    run(code, silent, source) {
      if (busy) return Promise.resolve();
      busy = true;
      this.classList.add('is-busy');
      if (!silent) pendingMessage = null;
      var self = this;
      var base = {
        code: code,
        source: source || (silent ? 'auto' : 'box'),
        context: this.dataset.context || 'drawer',
        codes_before: this.working(),
        subtotal: rupees(parseInt(this.dataset.subtotal, 10)),
        discount_before: rupees(parseInt(this.dataset.discount, 10))
      };
      track('coupon_apply_click', base);
      return applyCode(code, this.working(), {
        beforeSaving: parseInt(this.dataset.discount, 10) || 0,
        silent: silent
      }).then(function (result) {
        if (result && result.noop) self.say(result.message, 'info');
        if (result && result.ok) dropFromList(REMOVED_KEY, code);
        if (result) {
          var st = result.state || {};
          track('coupon_result', Object.assign({}, base, {
            result: result.noop ? 'already_applied' : (result.result || (result.ok ? 'applied' : 'failed')),
            applied: !!result.ok,
            codes_after: applicableCodes(st),
            discount_after: rupees(st.total_discount),
            total_after: rupees(st.total_price)
          }));
        }
        return result;
      }).catch(function () {
        self.say(t('network'), 'error');
      }).finally(function () {
        busy = false;
        self.classList.remove('is-busy');
      });
    }

    onSubmit(event) {
      event.preventDefault();
      var code = (this.input.value || '').trim().toUpperCase();
      if (!code) {
        this.say(t('empty'), 'error');
        this.input.focus();
        return;
      }
      this.run(code, false, 'box');
    }

    onClick(event) {
      if (event.target.closest('[data-mm-offers-apply]')) {
        this.onSubmit(event);
        return;
      }
      var use = event.target.closest('[data-mm-offers-use]');
      var remove = event.target.closest('[data-mm-offers-remove]');
      var more = event.target.closest('[data-mm-offers-more]');
      if (use) {
        this.run(use.dataset.mmOffersUse, false, 'offer');
      } else if (remove) {
        this.removeCode(remove.dataset.mmOffersRemove);
      } else if (more) {
        if (!more.dataset.label) more.dataset.label = more.textContent;
        var open = more.getAttribute('aria-expanded') !== 'true';
        this.querySelectorAll('[data-mm-offers-extra]').forEach(function (li) { li.hidden = !open; });
        more.setAttribute('aria-expanded', String(open));
        more.textContent = open ? t('showFewer') : more.dataset.label;
      }
    }

    removeCode(code) {
      if (busy) return;
      busy = true;
      this.classList.add('is-busy');
      addToList(REMOVED_KEY, code);
      var self = this;
      track('coupon_remove', { code: code, context: this.dataset.context || 'drawer' });
      setCodes(this.working().filter(function (c) { return c !== code; }))
        .then(function (s) { finish(s, t('removed', { code: code }), 'info'); })
        .catch(function () { self.say(t('network'), 'error'); })
        .finally(function () { busy = false; self.classList.remove('is-busy'); });
    }

    autoApply() {
      if (busy) return;
      var working = this.working();
      var removed = readList(REMOVED_KEY);
      var tried = readList(TRIED_KEY);
      /* Festive Sale (14 Oct 2026): while a phase runs (window.MMSale from snippets/mm-sale-core.liquid) the sale code
         is the only offer. It is tried once per visit like MOOD5, even when MOOD5 or GOODMOOD is already on the tote:
         they can't be combined with it, and applyCode keeps whichever saves more (the sale code) and says so. A shopper
         who removes it is not given it back in the same visit. Between phases and after the sale nothing here runs. */
      var sale = window.MMSale;
      if (sale && sale.on && sale.code) {
        var saleCode = String(sale.code).trim().toUpperCase();
        if (working.indexOf(saleCode) !== -1 || removed.indexOf(saleCode) !== -1 || tried.indexOf(saleCode) !== -1 || saleTried[saleCode]) return;
        saleTried[saleCode] = true;
        /* remembered for the visit only once it worked or another code was kept, so a failed first try
           (discount not live yet, network) is tried again on the next page */
        this.run(saleCode, true, 'auto').then(function (r) { if (r && (r.ok || r.result === 'kept_other')) addToList(TRIED_KEY, saleCode); });
        return;
      }
      var subtotal = parseInt(this.dataset.subtotal, 10) || 0;
      var isNew = this.dataset.newCustomer === 'true';
      /* A code claimed from the welcome popup counts as eligible, even when signed out. */
      var claimed = '';
      try { claimed = (localStorage.getItem('mmWelcomeCode') || '').toUpperCase(); } catch (e) {}
      var candidates = (this.data.offers || []).filter(function (o) {
        return o.auto && (!o.firstOrder || isNew || o.code === claimed) && (o.min || 0) <= subtotal &&
          removed.indexOf(o.code) === -1 && tried.indexOf(o.code) === -1;
      }).sort(function (a, b) { return (b.priority || 0) - (a.priority || 0); });
      /* With a code already working, only a code claimed from the welcome popup is still
         worth trying: applyCode keeps whichever of the two saves more and says so. */
      if (working.length > 0) {
        candidates = candidates.filter(function (o) { return o.code === claimed && working.indexOf(o.code) === -1; });
      }
      if (!candidates.length) return;
      var code = candidates[0].code;
      addToList(TRIED_KEY, code);
      var self = this;
      this.run(code, true, 'auto').then(function (result) {
        /* If it did not apply, the next candidate gets its turn on the next render. */
        if (result && !result.ok) setTimeout(function () {
          var fresh = document.querySelector('mm-cart-offers');
          if (fresh && fresh !== self) fresh.autoApply();
        }, 0);
      });
    }
  }

  customElements.define('mm-cart-offers', MmCartOffers);
})();
